import { render, staticRenderFns } from "./UserSettings.vue?vue&type=template&id=53da1cdb&"
import script from "./UserSettings.vue?vue&type=script&lang=js&"
export * from "./UserSettings.vue?vue&type=script&lang=js&"
import style0 from "./UserSettings.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\YrtDev\\wms\\wms-site\\main\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53da1cdb')) {
      api.createRecord('53da1cdb', component.options)
    } else {
      api.reload('53da1cdb', component.options)
    }
    module.hot.accept("./UserSettings.vue?vue&type=template&id=53da1cdb&", function () {
      api.rerender('53da1cdb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Layout/components/UserSettings.vue"
export default component.exports